/**
 * zipFirst — s110 (Dr. Rami, TestFlight build 77, 2026-10-17: "List view should still be same results but in the
 * zip code selected first then beyond"; mockup "Orella Doctors Start Case" D2). The SAME rows, re-ordered: those
 * whose office is in the selected ZIP first, then the rest, each part keeping the order it came in (by distance).
 * PURE, no imports: scripts/check-zip-first.mjs imports it under plain node.
 */
export function rowZip5(r) {
  const m = String((r && r.address && r.address.zip) || '').match(/^\s*(\d{5})/)
  return m ? m[1] : ''
}

export function zipFirst(rows, zip) {
  const z = (String(zip || '').match(/^\s*(\d{5})/) || [])[1] || ''
  const list = Array.isArray(rows) ? rows : []
  if (!z) return { rows: list, inZip: 0, zip: '' }
  const inZip = list.filter((r) => rowZip5(r) === z)
  const beyond = list.filter((r) => rowZip5(r) !== z)
  return { rows: [...inZip, ...beyond], inZip: inZip.length, zip: z }
}
